import React, { Component } from "react";

import { Select } from "antd";

export default class SelectOptions extends Component {
  render() {
    return (
      <Select
        showSearch={this.props.showSearch || true}
        style={this.props.style}
        value={this.props.value}
        placeholder={this.props.placeholder}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        name={this.props.name}
        filterOption={(value, option) => {
          if (value.length < 2) return true;

          return (
            (this.props.searchOnTitle && option.props.title.toLowerCase().includes(value.toLowerCase())) ||
            option.props.children.toLowerCase().includes(value.toLowerCase())
          );
        }}
        mode={this.props.mode}
      >
        {this.props.options &&
          this.props.options.map((option, index) => {
            let key = index + "-" + option.code;
            if (this.props.optionKey) {
              if (typeof this.props.optionKey === "function") {
                key = this.props.optionKey(option, index);
              } else {
                key = option[this.props.optionKey];
              }
            }

            let value = option.code || option;
            if (this.props.optionValue) {
              if (typeof this.props.optionValue === "function") {
                value = this.props.optionValue(option, index);
              } else {
                value = option[this.props.optionValue];
              }
            }

            let content = option.name || option;
            if (this.props.optionContent) {
              if (typeof this.props.optionContent === "function") {
                content = this.props.optionContent(option, index);
              } else {
                content = option[this.props.optionContent];
              }
            }

            let title = option.title;
            if (this.props.optionTitle) {
              if (typeof this.props.optionTitle === "function") {
                title = this.props.optionTitle(option, index);
              } else {
                title = option[this.props.optionTitle];
              }
            }

            return (
              value && <Select.Option key={key} value={value} title={title || content}>
                {content}
              </Select.Option>
            );
          })}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/SelectOptions/SelectOptions.js